import { all } from 'redux-saga/effects';
import authSagas from '@iso/redux/auth/saga';
import userSagas from '@iso/redux/user/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    userSagas(),
  ]);
}
